import { useState, useEffect } from "react";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";

import { CheckCircle, Clock, MessageCircle, Users, Zap, Brain } from "lucide-react";

const ThankYou = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Load the video script
    const script = document.createElement("script");
    script.src = "https://scripts.converteai.net/0ea963d5-0812-4a2e-a9b9-9a4016a95c82/players/68b6f6442a3de119c45fcf5f/v4/player.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector(`script[src="${script.src}"]`);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Simplified Header with Logo Only */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200/50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center h-16 lg:h-20">
            <Logo />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div>
            <div className="max-w-4xl mx-auto text-center">
              {/* Main Title */}
              <h1 className="text-4xl md:text-6xl font-bold mb-8">
                <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Como lojas de veículos estão aumentando em até 30% a geração de receita com essa Infraestrutura de IA.
                </span>
              </h1>

              {/* Video Container */}
              <div 
                className="mt-8 w-full max-w-4xl mx-auto"
                dangerouslySetInnerHTML={{
                  __html: `<vturb-smartplayer id="vid-68b6f6442a3de119c45fcf5f" style="display: block; margin: 0 auto; width: 100%; "></vturb-smartplayer> <script type="text/javascript"> var s=document.createElement("script"); s.src="https://scripts.converteai.net/0ea963d5-0812-4a2e-a9b9-9a4016a95c82/players/68b6f6442a3de119c45fcf5f/v4/player.js", s.async=!0,document.head.appendChild(s); </script>`
                }}
              />

              {/* Decorative Elements */}
              <div className="absolute top-20 left-10 w-20 h-20 bg-blue-200/30 rounded-full blur-xl animate-pulse" />
              <div className="absolute bottom-20 right-10 w-32 h-32 bg-purple-200/30 rounded-full blur-xl animate-pulse delay-1000" />
              <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-pink-200/30 rounded-full blur-xl animate-pulse delay-500" />
            </div>
          </div>
        </div>
      </main>

      <Footer showNav={false} />
    </div>
  );
};

export default ThankYou;
